/**
 * Facets Filters - Gestión de eventos y estado de filtros
 */

document.addEventListener('DOMContentLoaded', function () {

  // Función para actualizar el estado de los botones del footer
  function updateFilterButtonsState() {
    const checkedFilters = document.querySelectorAll('.wt-filter .form-checkbox__input:checked');
    const clearButton = document.querySelector('.wt-filter__remove-all');
    const applyButton = document.getElementById('ApplyFilters');

    const hasActiveFilters = checkedFilters.length > 0;

    if (clearButton) {
      clearButton.disabled = !hasActiveFilters;
    }
    if (applyButton) {
      applyButton.disabled = !hasActiveFilters;
    }
  }

  // Función para vincular eventos a checkboxes
  function bindCheckboxEvents(root = document) {
    const checkboxes = root.querySelectorAll('.wt-filter .form-checkbox__input');

    checkboxes.forEach(checkbox => {
      checkbox.removeEventListener('change', handleCheckboxChange);
      checkbox.addEventListener('change', handleCheckboxChange);
    });
  }

  // Handler para el cambio en checkboxes
  function handleCheckboxChange(event) {
    const checkbox = event.target;
    const collapsibleSection = checkbox.closest('collapsible-section');
    // Intentionally no expand/collapse here; only chevron/header controls toggle.

    // Actualizar estado de botones
    updateFilterButtonsState();
  }

  // Vincular toggle de expand/collapse solo al header/chevron
  const headerClickHandler = function () {
    const filterSection = this.closest('.filter, collapsible-section');
    if (filterSection) {
      filterSection.classList.toggle('filter--expanded');
    }
  };

  function bindHeaderToggleEvents(root = document) {
    const filterHeaders = root.querySelectorAll('.wt-filter .filter .filter__header');
    filterHeaders.forEach(header => {
      header.removeEventListener('click', headerClickHandler);
      header.addEventListener('click', headerClickHandler);
    });
  }

  // Inicialización
  bindCheckboxEvents();
  bindHeaderToggleEvents();
  updateFilterButtonsState();

  // Re-vincular eventos después de que los filtros se actualicen vía AJAX
  document.addEventListener('facets:change', function () {
    setTimeout(() => {
      bindCheckboxEvents();
      bindHeaderToggleEvents();
      updateFilterButtonsState();
    }, 100);
  });
});

